module.exports = "/static/assets/9293bf98ba4486b28fd640db9dd29fba.png";